import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { MomentModule } from 'ngx-moment';

import { coerceToTimestamp } from './coerce';

@Component({
  selector: 'rt-assistant-cell-date',
  imports: [MomentModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `{{ time() | amDateFormat: 'll' }}`,
})
export class AssistantCellDateComponent {
  public static readonly NgInputs = [<const>'value'];

  protected readonly time = computed(() => coerceToTimestamp(this.value()));

  public readonly value = input<unknown>();
}
